import type { ChartExportFormat } from 'hooks/use-chart-export';

import { trackFullStoryEvent } from 'helpers/fullstory';

import {
  CHART_EVENT,
  type ChartExportStatus,
} from './chart-analytics.constants';
import type { ChartViewMode } from '../components/chat/parts/chart-part-frame';

interface TrackChartExportedArgs {
  format: ChartExportFormat;
  viewMode: ChartViewMode;
  status: ChartExportStatus;
  chartTitle?: string;
}

export const trackChartExported = ({
  format,
  viewMode,
  status,
  chartTitle,
}: TrackChartExportedArgs): void => {
  trackFullStoryEvent(CHART_EVENT.exported, {
    format,
    viewMode,
    status,
    ...(chartTitle !== undefined && { chartTitle }),
  });
};
